import request from '@/utils/httpRequest'

export default class BaseBuildingService {
    queryById(id) {
        return request({
            url: '/base/wuyeBaseBuilding/queryById',
            method: 'get',
            params: { id: id }
        })
    }

    startFlow(params) {
        return request({
            url: '/base/wuyeBaseBuilding/startFlow',
            method: 'post',
            data: params
        })
    }

}
